import { formatDate as f } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/format.js";
import { formatters as g } from "./formatters/index.js";
import { toDate as d } from "../toDate/index.js";
const p = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function b(o, c, n = {}) {
  c = String(c);
  const s = c.match(p);
  if (s) {
    const a = d(n.originalDate || o, n);
    c = s.reduce(function(r, e) {
      if (e[0] === "'")
        return r;
      const t = r.indexOf(e), m = r[t - 1] === "'", i = r.replace(e, "'" + g[e[0]](a, e, n) + "'");
      return m ? i.substring(0, t - 1) + i.substring(t + 1) : i;
    }, c);
  }
  return f(o, c, n);
}
export {
  b as format
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/format/index.js
// module id = 1378
// module chunks = 67